<template>
<!-- 数字化转型新路径—智能决策 -->
 <div>
   <v-row>
     <v-col :cols="4">
       <v-row class="mx-0 mb-0" style="margin-top: 63px">
         <v-col :cols="12" style="height: 300px">
           <decision-making-card :title="items[0].title" :content-text="items[0].contentText">
           </decision-making-card>
         </v-col>
         <v-col :cols="12" style="margin-top: 80px">
           <decision-making-card :title="items[2].title" :content-text="items[2].contentText">
           </decision-making-card>
         </v-col>
       </v-row>
     </v-col>
     <v-col :cols="4">
       <div class="mx-0 mb-0" style="margin-top: 100px">
         <div style="height: 100%" class="d-flex flex-column align-center">
           <div class="grey lighten-4 pa-2">需要人工智能降门槛、降本增效</div>
           <div class="my-4" style="height: 100%;position: relative">
             <div style="position: absolute;top: 80px;left: 90px;white-space: nowrap">医生</div>
             <v-img :src="centerFlow" max-width="70px"></v-img>
             <div style="position: absolute;bottom: 90px;left: 90px;white-space: nowrap">药械企业</div>
           </div>
           <div class="grey lighten-4 pa-2">加速成果转化</div>
         </div>
       </div>
     </v-col>
     <v-col :cols="4">
       <v-row class="mx-0 mb-0" style="margin-top: 63px">
         <v-col :cols="12" style="height: 300px">
           <decision-making-card :title="items[1].title" :content-text="items[1].contentText">
           </decision-making-card>
         </v-col>
         <v-col :cols="12" style="margin-top: 80px">
           <decision-making-card :title="items[3].title" :content-text="items[3].contentText">
           </decision-making-card>
         </v-col>
       </v-row>
     </v-col>
   </v-row>
 </div>
</template>

<script>
import ImageInformation01 from '../../../../assets/pc/index/dss/信息化1.png'
import ImageInformation02 from '../../../../assets/pc/index/dss/信息化2.png'
import ImageInformation03 from '../../../../assets/pc/index/dss/信息化3.png'
import ImageInformation04 from '../../../../assets/pc/index/dss/信息化4.png'
// import ImageDigitization from '../../../../assets/pc/index/dss/数字化.png'
// import ImageIntelligentization from '../../../../assets/pc/index/dss/智能化.png'
import CenterFlow from '../../../../assets/pc/index/smart/centerFlow.png'
import DecisionMakingCard from './decision-making-card.vue'

export default {
  name: 'decision-making',
  components: {DecisionMakingCard},
  data () {
    return {
      centerFlow: CenterFlow,
      items: [
        {
          title: '需求',
          // image: ImageInformation01,
          // contentText: '信息化核心是模拟信息到数字信息的表征。主要以文本、图片、音、视频等文件存储为主的非结构化或半结构化数据，计算机很难理解和分析，知识应用难度大。'
          contentText: [
            '和职业生涯高度相关',
            '是职称晋升、评功评奖、基金申请、学术地位的重要评价指标',
            '降低参与临床科研的门槛',
            '提升临床科研的效率辅助完成医工结合'
          ]
        },
        {
          title: '需求',
          // image: ImageDigitization,
          contentText: [
            '临床医生对产品的认知提升',
            '获得更广泛的行业认可',
            '发现更多的临床应用价值',
            '物价和医保的数据支撑',
            '开展学术推广的支撑数据',
            '规范化临床应用的数据支撑'
          ]
        },
        {
          title: '痛点',
          // image: ImageIntelligentization,
          contentText: [
            '缺经费（配套的系统和工具)',
            '缺时间（文献和数据的处理和分析）',
            '缺团队（医工交叉的技术支撑）'
          ]
        },
        {
          title: '痛点',
          // image: ImageIntelligentization,
          contentText: [
            '资助临床科研成本高',
            '科研效率影响市场推广',
            '科研成果转化难度大'

          ]
        }
      ],

      informationBanner: [
        { name: 'ImageInformation01', image: ImageInformation01 },
        { name: 'ImageInformation02', image: ImageInformation02 },
        { name: 'ImageInformation03', image: ImageInformation03 },
        { name: 'ImageInformation04', image: ImageInformation04 }
      ],
      slidesValue: 0
    }
  }
}
</script>

<style scoped>
  .dmc-toggle-btn {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
  }
  .dmc-toggle-btn > div {
    height: 8px;
    border-radius: 6px;
    display: inline-block;
    cursor: pointer
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/dss/decision-making.vue